module.exports = __webpack_public_path__ + "img/9.4a886786.jpg";